import { doc, getDoc, onSnapshot, setDoc, updateDoc } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import './App.css'
import ParticleBackground from './components/ParticlesBackground'
import { db } from './db/index'
import Home from './pages/Home'

const SECRET_KEY = 'clave-secreta-123'

const App: React.FC = () => {
  const [bloqueado, setBloqueado] = useState<boolean | null>(null)
  const [enDesarrollo, setEnDesarrollo] = useState<boolean | null>(null)

  useEffect(() => {
    const docRef = doc(db, 'configuracion', 'app')

    const obtenerEstado = async () => {
      try {
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
          const data = docSnap.data()
          setBloqueado(data.bloqueado)
          setEnDesarrollo(data.enDesarrollo)
        } else {
          console.warn('El documento no existe en Firestore.')
        }
      } catch (error) {
        console.error('Error al obtener el estado inicial:', error)
      }
    }

    obtenerEstado()

    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data()
        setBloqueado(data.bloqueado)
        setEnDesarrollo(data.enDesarrollo)
      }
    })

    return () => unsubscribe()
  }, [])

  const cambiarEstado = async (estado: boolean, clave: string) => {
    if (clave !== SECRET_KEY) {
      console.log('Clave incorrecta, acceso denegado.')
      return
    }

    try {
      const docRef = doc(db, 'configuracion', 'app')
      const docSnap = await getDoc(docRef)

      if (!docSnap.exists()) {
        await setDoc(docRef, { bloqueado: estado, enDesarrollo: false })
        console.log('Documento creado con estado bloqueado:', estado)
      } else {
        await updateDoc(docRef, { bloqueado: estado })
        console.log(estado ? 'Aplicación bloqueada' : 'Aplicación desbloqueada')
      }
    } catch (error) {
      console.error('Error al actualizar Firestore:', error)
    }
  }

  const cambiarModoDesarrollo = async (estado: boolean, clave: string) => {
    if (clave !== SECRET_KEY) {
      console.log('Clave incorrecta, acceso denegado.')
      return
    }

    try {
      const docRef = doc(db, 'configuracion', 'app')
      const docSnap = await getDoc(docRef)

      if (!docSnap.exists()) {
        await setDoc(docRef, { bloqueado: false, enDesarrollo: estado })
        console.log('Documento creado con modo desarrollo:', estado)
      } else {
        await updateDoc(docRef, { enDesarrollo: estado })
        console.log(estado ? 'Aplicación marcada como en desarrollo' : 'Modo desarrollo desactivado')
      }
    } catch (error) {
      console.error('Error al actualizar Firestore:', error)
    }
  }

  ;(window as any).bloquearApp = (clave: string) => cambiarEstado(true, clave)
  ;(window as any).desbloquearApp = (clave: string) => cambiarEstado(false, clave)
  ;(window as any).marcarEnDesarrollo = (clave: string) => cambiarModoDesarrollo(true, clave)
  ;(window as any).quitarEnDesarrollo = (clave: string) => cambiarModoDesarrollo(false, clave)

  if (enDesarrollo) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', fontSize: '24px', backgroundColor: '#fff3cd', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#856404' }}>
        <h1>Aplicación en desarrollo</h1>
        <p>Estamos trabajando para brindarte una mejor experiencia. Vuelve más tarde.</p>
      </div>
    )
  }

  if (bloqueado) {
    return (
      <div style={{ textAlign: 'center', padding: '50px', fontSize: '24px', backgroundColor: '#f8d7da', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: '#721c24' }}>
        <h1>Acceso bloqueado</h1>
        <p>Falta de pago. Contacta con soporte para más información.</p>
      </div>
    )
  }

  return (
    <div className="app-container">
      <Home />
      <ParticleBackground />
    </div>
  )
}

export default App
